import { Box, CircularProgress, CircularProgressPropsColorOverrides } from '@mui/material';
import classes from './LoadingSpinner.module.scss';
import { CSSProperties, FC } from 'react';
import { OverridableStringUnion } from '@mui/types';

type LoadingSpinnerProps = {
  size?: 'small' | 'default';
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit',
    CircularProgressPropsColorOverrides
  >;
  style?: CSSProperties;
};

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'default', style, color }) => {
  return (
    // <div className={classes.spinner__wrapper}>
    //   <div className={classes.spinner}></div>
    // </div>
    <Box
      sx={{ display: 'flex', ...style }}
      className={size == 'small' ? classes.spinnerWrapperSmall : classes.spinnerWrapper}
    >
      <CircularProgress size={size == 'small' ? 20 : 40} color={color} />
    </Box>
  );
};

export default LoadingSpinner;
